import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';
import EventScope from 'owa-service/lib/contract/EventScope';

export function getEventScope(item: MeetingCancellationMessageType): EventScope {
    /**
     * Ideally, we would just check CalendarItemType but it seems broken.
     * 'Single' is returned in the 'Instance' case. To account for this, we check for
     * the presence of a RecurrenceId. If the item has a ReccurenceId, we are dealing
     * with an instance of a series
     **/
    if (item.CalendarItemType === 'RecurringMaster') {
        return EventScope.AllInstancesInSeries;
    } else if (
        item.CalendarItemType === 'Single' &&
        item.RecurrenceId /** recurrenceId indicates instance */
    ) {
        return EventScope.ThisInstanceOnly;
    } else {
        return EventScope.Default;
    }
}
